import { render, staticRenderFns } from "./JoaDemoForm.vue?vue&type=template&id=1438628e&scoped=true&"
import script from "./JoaDemoForm.vue?vue&type=script&lang=js&"
export * from "./JoaDemoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1438628e",
  null
  
)

export default component.exports